// | Graphical widgets for Restaumatic.Form, using Bootstrap styling. Applicable in PR and HQ.
import * as $runtime from "../runtime.js";
import * as Control$dApply from "../Control.Apply/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dHeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Restaumatic$dComponents$dMultiSelect from "../Restaumatic.Components.MultiSelect/index.js";
import * as Restaumatic$dForm$dCheckbox from "../Restaumatic.Form.Checkbox/index.js";
import * as Restaumatic$dForm$dFormField from "../Restaumatic.Form.FormField/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dList from "../Restaumatic.Form.List/index.js";
import * as Restaumatic$dForm$dMapping from "../Restaumatic.Form.Mapping/index.js";
import * as Restaumatic$dForm$dQuery from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic$dForm$dTranslated from "../Restaumatic.Form.Translated/index.js";
import * as Restaumatic$dForm$dWidgets from "../Restaumatic.Form.Widgets/index.js";
import * as Restaumatic$dI18n$dCurrency from "../Restaumatic.I18n.Currency/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular$dComponents$dCommon from "../Specular.Components.Common/index.js";
import * as Specular$dComponents$dIconList from "../Specular.Components.IconList/index.js";
import * as Specular$dComponents$dIcons from "../Specular.Components.Icons/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dExtra from "../Specular.FRP.Extra/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dEffect from "../Specular.Internal.Effect/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dJQuery from "../Specular.JQuery/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Specular$dSelect from "../Specular.Select/index.js";
import * as Type$dEquality from "../Type.Equality/index.js";
const $DefaultEmptyLabel = () => ({tag: "DefaultEmptyLabel"});
const $LabelMode = tag => ({tag});
const $UseDefault = () => ({tag: "UseDefault"});
const newRef = /* #__PURE__ */ Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO);
const monadFRP = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder};
const attachDyn = /* #__PURE__ */ (() => {
  const subscribeDyn_$1 = Specular$dFRP$dBase.subscribeDyn_(monadFRP);
  return dyn => cb => subscribeDyn_$1(cb)(dyn);
})();
const unlessD = /* #__PURE__ */ Specular$dFRP$dExtra.unlessD(monadFRP)(Specular$dDom$dBuilder.monadReplaceBuilder);
const whenD = /* #__PURE__ */ Specular$dFRP$dExtra.whenD(monadFRP)(Specular$dDom$dBuilder.monadReplaceBuilder);
const readLabel = /* #__PURE__ */ Restaumatic$dForm$dMapping.readLabel(Restaumatic$dForm$dMapping.mappingLikeMapping);
const withUniqDynamic_ = /* #__PURE__ */ Specular$dFRP$dExtra.withUniqDynamic_(monadFRP)(Specular$dDom$dBuilder.monadReplaceBuilder);
const withUniqDynamic_1 = /* #__PURE__ */ withUniqDynamic_({eq: /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)});
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Specular$dInternal$dRIO.applicativeRIO)(Data$dFoldable.foldableArray);
const uniqDyn = /* #__PURE__ */ (() => {
  const uniqDynBy1 = Specular$dFRP$dBase.uniqDynBy(monadFRP);
  return dictEq => uniqDynBy1(dictEq.eq);
})();
const subscribeDyn_ = /* #__PURE__ */ Specular$dFRP$dBase.subscribeDyn_(monadFRP);
const withDynamic_ = /* #__PURE__ */ Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)(monadFRP);
const identity = x => x;
const fold = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Specular$dDom$dElement.monoidProp)(Data$dFoldable.identity))();
const UseDefault = /* #__PURE__ */ $UseDefault();
const LabelDefault = /* #__PURE__ */ $LabelMode("LabelDefault");
const LabelBooleanControl = /* #__PURE__ */ $LabelMode("LabelBooleanControl");
const DefaultEmptyLabel = /* #__PURE__ */ $DefaultEmptyLabel();
const toGroupNameUseDefault = {toGroupName: v => v.fieldId};
const toGroupNameString = {toGroupName: v => v.value};
const fieldLabelDefaultEmptyLab = {renderLabelWithMode: v => v1 => Restaumatic$dPrelude$dSpecular.wempty, isVisible: v => v1 => false, isDefault: v => true};
const wrapItem = /* #__PURE__ */ Specular$dDom$dElement.el("div")([
  /* #__PURE__ */ Specular$dDom$dElement.attr("style")("margin: 5px; margin-left: 10px; padding: 5px; border: 1px solid black;")
]);
const translatedFieldWrapper = body => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("input-group")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
  Specular$dDom$dElement.attr("title")("Pole tłumaczone"),
  Specular$dDom$dElement.class_("input-group-addon")
])(Specular$dDom$dElement.el("span")([Specular$dDom$dElement.attr("aria-hidden")("true"), Specular$dDom$dElement.class_("icon-flag")])(Restaumatic$dPrelude$dSpecular.wempty)))(() => body));
const toGroupName = dict => dict.toGroupName;
const sortIcon = /* #__PURE__ */ Specular$dInternal$dRIO.bindImpl(/* #__PURE__ */ Specular$dDom$dElement.el("i")([/* #__PURE__ */ Specular$dDom$dElement.class_("icon-sort")])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dDom$dElement.text(" "));
const renderLabelWithMode = dict => dict.renderLabelWithMode;
const renderLabel = dictFieldLabel => dictFieldLabel.renderLabelWithMode(LabelDefault);
const plusIcon = /* #__PURE__ */ Specular$dInternal$dRIO.applyImpl(/* #__PURE__ */ Specular$dInternal$dRIO.mapImpl(v => Control$dApply.identity)(/* #__PURE__ */ Specular$dDom$dElement.el("span")([
  /* #__PURE__ */ Specular$dDom$dElement.attr("aria-hidden")("true"),
  /* #__PURE__ */ Specular$dDom$dElement.class_("icon-plus-sign")
])(Restaumatic$dPrelude$dSpecular.wempty)))(/* #__PURE__ */ Specular$dDom$dElement.text(" "));
const panelToggle = label1 => forceExpand => body => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.readDynamic(Specular$dInternal$dRIO.monadEffectRIO)(forceExpand))(newRef))(expanded => Specular$dInternal$dRIO.bindImpl(attachDyn(forceExpand)(b => expanded._2(b$1 => b || b$1)))(() => Specular$dDom$dElement.el("div")([
  Specular$dDom$dElement.class_("panel"),
  Specular$dDom$dElement.class_("panel-default")
])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("panel-heading"), Specular$dDom$dElement.class_("sortable-handle")])(Specular$dInternal$dRIO.bindImpl(unlessD(forceExpand)(Specular$dDom$dElement.el("button")([
  Specular$dDom$dElement.onClick_(expanded._2(Data$dHeytingAlgebra.boolNot)),
  Specular$dDom$dElement.attr("type")("button"),
  Specular$dDom$dElement.class_("btn"),
  Specular$dDom$dElement.class_("btn-default"),
  Specular$dDom$dElement.class_("btn-sm"),
  Specular$dDom$dElement.class_("pull-right")
])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
  Specular$dDom$dElement.attr("aria-hidden")("true"),
  Specular$dDom$dElement.classWhenD(expanded._1)("icon-caret-up"),
  Specular$dDom$dElement.classUnlessD(expanded._1)("icon-caret-down")
])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => Specular$dInternal$dRIO.bindImpl(whenD(expanded._1)(Specular$dDom$dElement.text("Zwiń")))(() => unlessD(expanded._1)(Specular$dDom$dElement.text("Rozwiń"))))))))(() => label1)))(() => whenD(expanded._1)(Specular$dDom$dElement.el("div")([
  Specular$dDom$dElement.class_("panel-body")
])(body))))));
const panel$p = label1 => body => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("panel"), Specular$dDom$dElement.class_("panel-default")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([
  Specular$dDom$dElement.class_("panel-heading"),
  Specular$dDom$dElement.class_("sortable-handle")
])(label1))(() => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("panel-body")])(body)));
const panel = classes$p => body => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(Data$dSemigroup.concatArray(["panel", "panel-default"])(classes$p))])(Specular$dDom$dElement.el("div")([
  Specular$dDom$dElement.class_("panel-body")
])(body));
const panel_ = body => panel([])(body);
const labelWidget = dictTypeEquals => {
  const from = dictTypeEquals.proof(a => a);
  return {renderLabelWithMode: v => Specular$dDom$dBuilder.local(from), isVisible: v => v1 => true, isDefault: v => false};
};
const labelUnit = {renderLabelWithMode: v => v1 => Restaumatic$dPrelude$dSpecular.wempty, isVisible: v => v1 => false, isDefault: v => false};
const label = /* #__PURE__ */ Specular$dDom$dElement.el("label")([/* #__PURE__ */ Specular$dDom$dElement.class_("control-label")]);
const labelString = {
  renderLabelWithMode: v => v1 => {
    if (v1 === "") { return Restaumatic$dPrelude$dSpecular.wempty; }
    if (v.tag === "LabelDefault") { return label(Specular$dDom$dElement.text(v1)); }
    if (v.tag === "LabelBooleanControl") { return Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("control-label")])(Specular$dDom$dElement.text(v1)); }
    $runtime.fail();
  },
  isVisible: v => v1 => {
    if (v.tag === "LabelDefault") { return !(v1 === ""); }
    return true;
  },
  isDefault: v => false
};
const isVisible = dict => dict.isVisible;
const isDefault = dict => dict.isDefault;
const isVisibleFieldLabel = dictFieldLabel => l => fieldLabelD => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.readDynamic(Specular$dInternal$dRIO.monadEffectRIO)(fieldLabelD))(fieldLabel => Specular$dInternal$dRIO.pureImpl((() => {
  if (fieldLabel.tag === "Just") {
    if (dictFieldLabel.isDefault(l)) { return fieldLabel._1 !== ""; }
    return dictFieldLabel.isVisible(LabelDefault)(l);
  }
  return dictFieldLabel.isVisible(LabelDefault)(l);
})()));
const renderFieldLabel = dictFieldLabel => {
  const renderLabel2 = dictFieldLabel.renderLabelWithMode(LabelDefault);
  return l => fieldLabelD => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.readDynamic(Specular$dInternal$dRIO.monadEffectRIO)(fieldLabelD))(fieldLabel => {
    if (fieldLabel.tag === "Just") {
      if (dictFieldLabel.isDefault(l)) { return labelString.renderLabelWithMode(LabelDefault)(fieldLabel._1); }
      return renderLabel2(l);
    }
    return renderLabel2(l);
  });
};
const mappingField = dictOrd => {
  const display = Restaumatic$dForm$dMapping.display(dictOrd)(monadFRP)(Specular$dDom$dBuilder.monadReplaceBuilder)(Restaumatic$dForm$dMapping.mappingLikeMapping);
  return dictFieldLabel => {
    const renderFieldLabel1 = renderFieldLabel(dictFieldLabel);
    return label1 => f => renderItem => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["form-group"])])(Specular$dInternal$dRIO.bindImpl(renderFieldLabel1(label1)(readLabel(f)))(() => display(f)(renderItem)));
  };
};
const infoText = /* #__PURE__ */ Specular$dDom$dElement.el("p")([/* #__PURE__ */ Specular$dDom$dElement.class_("m-form__info-text")]);
const formGroup = label1 => body => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["form-group"])])(Specular$dInternal$dRIO.bindImpl(label1 !== ""
  ? Specular$dDom$dElement.el("label")([Specular$dDom$dElement.class_("control-label")])(Specular$dDom$dElement.text(label1))
  : Specular$dInternal$dRIO.pureImpl())(() => body));
const fieldset$p = label1 => body => Specular$dDom$dElement.el("fieldset")([Specular$dDom$dElement.class_("form-fieldset")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el_("legend")(label1))(() => body));
const fieldset = label1 => fieldset$p(Specular$dDom$dElement.text(label1));
const errorMessage = error => Specular$dDom$dElement.el("p")([Specular$dDom$dElement.class_("invalid-feedback")])(Specular$dInternal$dRIO.bindImpl(Specular$dComponents$dIcons.icon([
  Specular$dComponents$dCommon.classModifier("md-18")
])(Specular$dComponents$dIconList.$Icon("error")))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => Specular$dDom$dElement.text(error))));
const displayErrorMessage = dictHasErrors => f => withUniqDynamic_1(dictHasErrors.displayedErrors(f))(errors => for_(errors)(errorMessage));
const radioGroup = () => dictHasErrors => {
  const hasDisplayedErrors = Restaumatic$dForm$dInternal.hasDisplayedErrors(dictHasErrors);
  return dictIsSelectField => dictToOptionId => dictHasFieldId => dictFieldLabel => dictToGroupName => dictShow => dictEq => {
    const withUniqDynamic_2 = withUniqDynamic_({eq: Data$dEq.eqArrayImpl(ra => rb => ra.disabled === rb.disabled && dictEq.eq(ra.key)(rb.key) && ra.label === rb.label)});
    return () => () => params => {
      const $0 = {label: DefaultEmptyLabel, props: [], groupName: UseDefault, ...params};
      const field = $0.field;
      return Specular$dDom$dElement.el("div")([
        Specular$dDom$dElement.classes(["form-group", "form-field"]),
        Restaumatic$dForm$dWidgets.fieldId(dictHasFieldId)(field),
        Specular$dDom$dElement.attr("data-field-type")("radioGroup"),
        Specular$dDom$dElement.classWhenD(hasDisplayedErrors(field))("has-error")
      ])(Specular$dInternal$dRIO.bindImpl(withUniqDynamic_2(Specular$dFRP$dBase.functorDynamic.map(Specular$dSelect.flattenOptions)(dictIsSelectField.selectGetOptions(field)))(opts => for_(opts)(option => Specular$dDom$dElement.el("div")([
        Specular$dDom$dElement.class_("radio"),
        Specular$dDom$dElement.attr("data-option-id")(dictToOptionId.toOptionId(option.key))
      ])(Specular$dDom$dElement.el_("label")(Specular$dInternal$dRIO.bindImpl(Restaumatic$dForm$dWidgets.radio(dictShow)(dictEq)(dictIsSelectField)(dictToGroupName.toGroupName({
        fieldId: dictHasFieldId.getFieldId(field),
        value: $0.groupName
      }))(option)($0.props)(field))(() => labelString.renderLabelWithMode(LabelBooleanControl)(option.label)))))))(() => withUniqDynamic_1(dictHasErrors.displayedErrors(field))(errors => for_(errors)(errorMessage))));
    };
  };
};
const selectField = () => dictIsSelectField => dictHasErrors => {
  const hasDisplayedErrors = Restaumatic$dForm$dInternal.hasDisplayedErrors(dictHasErrors);
  return dictHasFieldId => dictHasLabel => dictFieldLabel => {
    const renderLabel2 = dictFieldLabel.renderLabelWithMode(LabelDefault);
    return dictShow => {
      const select = Restaumatic$dForm$dWidgets.select(dictShow);
      return dictEq => {
        const uniqDyn1 = uniqDyn({
          eq: Data$dEq.eqArrayImpl(Specular$dSelect.eqOption({
            eq: x => y => {
              if (x.tag === "Nothing") { return y.tag === "Nothing"; }
              if (x.tag === "Just") {
                if (y.tag === "Just") { return dictEq.eq(x._1)(y._1); }
                return false;
              }
              return false;
            }
          }).eq)
        });
        const select1 = select(dictEq);
        return dictToOptionId => {
          const toOptionIdMaybe = {
            toOptionId: v => {
              if (v.tag === "Nothing") { return ""; }
              if (v.tag === "Just") { return dictToOptionId.toOptionId(v._1); }
              $runtime.fail();
            }
          };
          const fromSelectOptions = Restaumatic$dComponents$dMultiSelect.fromSelectOptions(toOptionIdMaybe);
          const select2 = select1(dictToOptionId)(dictIsSelectField);
          return () => () => params => {
            const $0 = {label: DefaultEmptyLabel, props: [], select2: false, ...params};
            const field = $0.field;
            return Specular$dDom$dElement.el("div")([
              Restaumatic$dForm$dWidgets.fieldId(dictHasFieldId)(field),
              Specular$dDom$dElement.class_("form-field"),
              Specular$dDom$dElement.classWhenD(hasDisplayedErrors(field))("has-error"),
              (() => {
                if (!$0.select2) { return Specular$dDom$dElement.monoidProp.mempty; }
                if ($0.select2) { return Specular$dDom$dElement.attr("data-custom-field-type")("select2"); }
                $runtime.fail();
              })()
            ])(Specular$dInternal$dRIO.bindImpl(withDynamic_(Specular$dFRP$dBase.functorDynamic.map(v2 => {
              if (v2.tag === "Nothing") { return ""; }
              if (v2.tag === "Just") { return v2._1; }
              $runtime.fail();
            })(dictHasLabel.getLabel(field)))(fieldLabel => {
              if (dictFieldLabel.isDefault($0.label)) { return labelString.renderLabelWithMode(LabelDefault)(fieldLabel); }
              return renderLabel2($0.label);
            }))(() => Specular$dInternal$dRIO.bindImpl((() => {
              if ($0.select2) {
                const selectInput2 = Restaumatic$dForm$dInternal.selectInput(dictShow)(dictEq)(dictIsSelectField)($0.field);
                return Specular$dInternal$dRIO.bindImpl(uniqDyn1(selectInput2.displayedOptions))(optionsD => {
                  const entriesD = Specular$dFRP$dBase.functorDynamic.map(fromSelectOptions)(optionsD);
                  return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el$p("input")($0.props)(Restaumatic$dPrelude$dSpecular.wempty))(v => {
                    const jq = Specular$dJQuery.fromNode(v._1);
                    return Specular$dInternal$dRIO.bindImpl(Restaumatic$dComponents$dMultiSelect.initSelect2Impl(jq)({
                      data: (() => {
                        const $1 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(entriesD);
                        return () => {
                          const a$p = $1();
                          return {results: a$p};
                        };
                      })(),
                      containerCssClass: "form-control",
                      multiple: false,
                      placeholder: ""
                    })({addCustomField: true}))(() => Specular$dInternal$dRIO.bindImpl(subscribeDyn_(value => Restaumatic$dComponents$dMultiSelect.setValue(jq)((() => {
                      if (value.tag === "Nothing") { return ""; }
                      if (value.tag === "Just") { return toOptionIdMaybe.toOptionId(value._1); }
                      $runtime.fail();
                    })()))(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v$1 => Control$dApply.identity)(optionsD))(selectInput2.displayedValue)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dJQuery.addEventListener("change")(v1 => {
                      const $1 = Restaumatic$dComponents$dMultiSelect.getValue(jq);
                      return () => {
                        const value = $1();
                        const opts = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(selectInput2.displayedOptions)();
                        return selectInput2.onChange((() => {
                          const $2 = Specular$dSelect.findOption(o => toOptionIdMaybe.toOptionId(o.key) === value)(opts);
                          if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
                          if ($2.tag === "Just") { return $2._1.key; }
                          $runtime.fail();
                        })())();
                      };
                    })(jq))(unsub => Specular$dInternal$dRIO.rio(env => Specular$dInternal$dEffect.pushDelayed(env.cleanup)(unsub)))));
                  });
                });
              }
              return select2(Data$dSemigroup.concatArray([Specular$dDom$dElement.class_("form-control")])($0.props))(field);
            })())(() => withUniqDynamic_1(dictHasErrors.displayedErrors(field))(errors => for_(errors)(errorMessage)))));
          };
        };
      };
    };
  };
};
const textField$p = dictHasErrors => {
  const hasDisplayedErrors = Restaumatic$dForm$dInternal.hasDisplayedErrors(dictHasErrors);
  return dictHasFieldId => dictFieldLabel => {
    const renderFieldLabel1 = renderFieldLabel(dictFieldLabel);
    return widget => params => {
      const field = params.field;
      return Specular$dInternal$dRIO.bindImpl(isVisibleFieldLabel(dictFieldLabel)(params.label)(params.fieldLabel))(labelVisible => Specular$dDom$dElement.el("div")([
        Restaumatic$dForm$dWidgets.fieldId(dictHasFieldId)(field),
        Specular$dDom$dElement.classes(["form-group", "form-field"]),
        Specular$dDom$dElement.classWhenD(hasDisplayedErrors(field))("has-error"),
        labelVisible ? Specular$dDom$dElement.monoidProp.mempty : Specular$dDom$dElement.class_("form-field--inline")
      ])(Specular$dInternal$dRIO.bindImpl((() => {
        const $0 = renderFieldLabel1(params.label)(params.fieldLabel);
        if (labelVisible) { return $0; }
        return Specular$dInternal$dRIO.pureImpl();
      })())(() => Specular$dInternal$dRIO.bindImpl(params.wrapper(widget(Data$dSemigroup.concatArray([Specular$dDom$dElement.class_("form-control")])(params.props))(field)))(() => {
        if (params.displayErrors) { return withUniqDynamic_1(dictHasErrors.displayedErrors(field))(errors => for_(errors)(errorMessage)); }
        return Restaumatic$dPrelude$dSpecular.wempty;
      }))));
    };
  };
};
const textField$p1 = /* #__PURE__ */ textField$p(Restaumatic$dForm$dFormField.hasErrorsFormField$p)(Restaumatic$dForm$dFormField.hasFieldIdFormField$p);
const textAreaField = dictHasErrors => {
  const textField$p2 = textField$p(dictHasErrors);
  return dictFieldLabel => dictIsTextField => dictHasLabel => dictHasFieldId => {
    const textField$p3 = textField$p2(dictHasFieldId)(dictFieldLabel);
    return () => () => params => {
      const $0 = {label: DefaultEmptyLabel, props: [], displayErrors: true, wrapper: identity, ...params};
      return textField$p3(Restaumatic$dForm$dWidgets.textArea(dictIsTextField))({...$0, fieldLabel: dictHasLabel.getLabel($0.field)});
    };
  };
};
const textField = dictHasErrors => {
  const textField$p2 = textField$p(dictHasErrors);
  return dictFieldLabel => dictIsTextField => dictHasLabel => dictHasFieldId => {
    const textField$p3 = textField$p2(dictHasFieldId)(dictFieldLabel);
    return () => () => params => {
      const $0 = {label: DefaultEmptyLabel, props: [], displayErrors: true, wrapper: identity, ...params};
      return textField$p3(Restaumatic$dForm$dWidgets.textInput(dictIsTextField))({...$0, fieldLabel: dictHasLabel.getLabel($0.field)});
    };
  };
};
const priceField = dictHasErrors => {
  const textField1 = textField(dictHasErrors);
  return dictIsTextField => dictHasFieldId => dictHasLabel => dictFieldLabel => {
    const textField2 = textField1(dictFieldLabel)(dictIsTextField)(dictHasLabel)(dictHasFieldId)()();
    return () => () => params => {
      const $0 = {label: "", props: [], ...params};
      return textField2({
        field: $0.field,
        label: $0.label,
        props: $0.props,
        displayErrors: false,
        wrapper: body => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("input-group")])(Specular$dInternal$dRIO.bindImpl(body)(() => Specular$dDom$dElement.el("span")([
          Specular$dDom$dElement.class_("input-group-addon")
        ])(Specular$dDom$dElement.text(Restaumatic$dI18n$dCurrency.currencyOptions($0.currency).unit))))
      });
    };
  };
};
const translatedTextAreaField = dictIsRefLike => dictHasContext => dictAsTranslatedString => dictFormFieldLike => {
  const textArea = Restaumatic$dForm$dWidgets.textArea({textInput: v => Restaumatic$dForm$dTranslated.translatedTextInput(dictIsRefLike)(dictHasContext)(dictAsTranslatedString)(v)});
  const readLabel1 = Restaumatic$dForm$dFormField.readLabel(dictFormFieldLike);
  return dictFieldLabel => dictIsTextField => dictHasFieldId => dictHasErrors => {
    const textField$p2 = textField$p(dictHasErrors)(dictHasFieldId)(dictFieldLabel);
    return () => () => params => {
      const $0 = {label: DefaultEmptyLabel, props: [], displayErrors: true, wrapper: translatedFieldWrapper, ...params};
      return textField$p2(textArea)({...$0, field: $0.field, fieldLabel: readLabel1($0.field)});
    };
  };
};
const translatedTextField = dictAsTranslatedString => {
  const textInput = Restaumatic$dForm$dWidgets.textInput({
    textInput: v => Restaumatic$dForm$dTranslated.translatedTextInput(Restaumatic$dForm$dFormField.isRefLikeFormField$p)(Restaumatic$dForm$dFormField.hasContextFormField$p)(dictAsTranslatedString)(v)
  });
  return dictFieldLabel => {
    const textField$p2 = textField$p1(dictFieldLabel);
    return () => () => params => {
      const $0 = {label: DefaultEmptyLabel, props: [], displayErrors: true, wrapper: translatedFieldWrapper, ...params};
      return textField$p2(textInput)({...$0, field: $0.field, fieldLabel: Restaumatic$dForm$dFormField.hasLabelFormField$p.getLabel($0.field)});
    };
  };
};
const displayErrorHint = dictHasErrors => f => withUniqDynamic_1(dictHasErrors.displayedErrors(f))(errors => for_(errors)(error => Specular$dDom$dElement.el("p")([
  Specular$dDom$dElement.class_("help-block")
])(Specular$dDom$dElement.text(error))));
const deleteButton = dictEq => item => Specular$dDom$dElement.el("button")([
  Specular$dDom$dElement.classes(["btn", "btn-default", "btn-sm"]),
  Specular$dDom$dElement.attr("type")("button"),
  Specular$dDom$dElement.onClick_(() => item.delete())
])(Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => Control$dApply.identity)(Specular$dDom$dElement.el("span")([
  Specular$dDom$dElement.attr("aria-hidden")("true"),
  Specular$dDom$dElement.class_("icon-trash")
])(Restaumatic$dPrelude$dSpecular.wempty)))(Specular$dDom$dElement.text(" ")))(() => Specular$dDom$dElement.text("Usuń")));
const dateTimeLocalField = dictIsRefLike => dictHasErrors => {
  const textField$p2 = textField$p(dictHasErrors);
  return dictAsDateTime => dictFieldLabel => dictHasLabel => dictHasFieldId => {
    const textField$p3 = textField$p2(dictHasFieldId)(dictFieldLabel);
    return () => () => params => {
      const $0 = {label: DefaultEmptyLabel, placeholder: "", props: [], displayErrors: true, min: Data$dMaybe.Nothing, ...params};
      return textField$p3(props => field => Restaumatic$dForm$dWidgets.dateTimePickerLocal(dictIsRefLike)(dictAsDateTime)()()({props, field, min: $0.min}))({
        field: $0.field,
        label: $0.label,
        fieldLabel: dictHasLabel.getLabel($0.field),
        props: [Specular$dDom$dElement.attr("placeholder")($0.placeholder), fold($0.props)],
        displayErrors: $0.displayErrors,
        wrapper: identity
      });
    };
  };
};
const dateField = dictIsRefLike => dictHasErrors => {
  const textField$p2 = textField$p(dictHasErrors);
  return dictAsDate => dictFieldLabel => dictHasLabel => dictHasFieldId => {
    const textField$p3 = textField$p2(dictHasFieldId)(dictFieldLabel);
    return () => () => params => {
      const $0 = {label: DefaultEmptyLabel, placeholder: "", props: [], displayErrors: true, ...params};
      return textField$p3(Restaumatic$dForm$dWidgets.datePicker(dictIsRefLike)(dictAsDate))({
        field: $0.field,
        label: $0.label,
        fieldLabel: dictHasLabel.getLabel($0.field),
        props: [Specular$dDom$dElement.attr("placeholder")($0.placeholder), fold($0.props)],
        displayErrors: $0.displayErrors,
        wrapper: identity
      });
    };
  };
};
const checkbox = dictFieldLabel => dictIsCheckboxField => dictHasFieldId => dictHasLabel => () => () => params => {
  const $0 = {label: DefaultEmptyLabel, props: [], withFieldId: true, ...params};
  return Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.class_("checkbox"),
    (() => {
      const $1 = Restaumatic$dForm$dWidgets.fieldId(dictHasFieldId)($0.field);
      if (!$0.withFieldId) { return Specular$dDom$dElement.monoidProp.mempty; }
      if ($0.withFieldId) { return $1; }
      $runtime.fail();
    })()
  ])(Specular$dDom$dElement.el_("label")(Specular$dInternal$dRIO.bindImpl(Restaumatic$dForm$dWidgets.checkbox(dictIsCheckboxField)($0.props)($0.field))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => withDynamic_(Specular$dFRP$dBase.functorDynamic.map(v2 => {
    if (v2.tag === "Nothing") { return ""; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  })(dictHasLabel.getLabel($0.field)))(fieldLabel => {
    if (dictFieldLabel.isDefault($0.label)) { return labelString.renderLabelWithMode(LabelBooleanControl)(fieldLabel); }
    return dictFieldLabel.renderLabelWithMode(LabelBooleanControl)($0.label);
  })))));
};
const checkboxField = dictFieldLabel => dictFieldLabel1 => dictIsCheckboxField => dictHasErrors => {
  const hasDisplayedErrors = Restaumatic$dForm$dInternal.hasDisplayedErrors(dictHasErrors);
  return dictHasLabel => dictHasFieldId => () => () => params => {
    const $0 = {label: DefaultEmptyLabel, title: "", props: [], ...params};
    const field = $0.field;
    return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([
      Restaumatic$dForm$dWidgets.fieldId(dictHasFieldId)(field),
      Specular$dDom$dElement.classes(["form-group", "form-field"]),
      Specular$dDom$dElement.classWhenD(hasDisplayedErrors(field))("has-error")
    ])(Specular$dInternal$dRIO.bindImpl((() => {
      const $1 = dictFieldLabel1.renderLabelWithMode(LabelBooleanControl)($0.title);
      if (dictFieldLabel1.isVisible(LabelDefault)($0.title)) { return $1; }
      return Specular$dInternal$dRIO.pureImpl();
    })())(() => checkbox(dictFieldLabel)(dictIsCheckboxField)(dictHasFieldId)(dictHasLabel)()()({label: $0.label, props: $0.props, field: $0.field, withFieldId: false}))))(() => withUniqDynamic_1(dictHasErrors.displayedErrors(field))(errors => for_(errors)(errorMessage)));
  };
};
const checkboxField1 = /* #__PURE__ */ checkboxField(labelString)(labelString)(/* #__PURE__ */ Restaumatic$dForm$dFormField.isCheckboxFieldFormField$p(Restaumatic$dForm$dCheckbox.asCheckboxStateBoolean))(Restaumatic$dForm$dFormField.hasErrorsFormField$p)(Restaumatic$dForm$dFormField.hasLabelFormField$p)(Restaumatic$dForm$dFormField.hasFieldIdFormField$p)()();
const optionalWidget = label1 => f => renderSubform => Specular$dInternal$dRIO.bindImpl(checkboxField1({label: label1, field: f.exists}))(() => whenD(Restaumatic$dForm$dQuery.queryLaxWithDefault(Restaumatic$dForm$dFormField.queryFormField$p(Type$dEquality.refl))(false)(f.exists))(renderSubform(f.subform)));
const alertWarning = /* #__PURE__ */ Specular$dDom$dElement.el("div")([
  /* #__PURE__ */ Specular$dDom$dElement.class_("alert"),
  /* #__PURE__ */ Specular$dDom$dElement.class_("alert-warning")
]);
const displayAlertWarning = dictHasErrors => f => withUniqDynamic_1(dictHasErrors.displayedErrors(f))(errors => for_(errors)(error => alertWarning(Specular$dDom$dElement.text(error))));
const alertInfo = /* #__PURE__ */ Specular$dDom$dElement.el("div")([
  /* #__PURE__ */ Specular$dDom$dElement.class_("alert"),
  /* #__PURE__ */ Specular$dDom$dElement.class_("alert-info")
]);
const addButton = dictOrd => {
  const pushItem = Restaumatic$dForm$dList.pushItem(dictOrd);
  return dictShow => {
    const pushItem1 = pushItem(dictShow)(Restaumatic$dForm$dList.listLikeList$p);
    return l => Specular$dDom$dElement.el("button")([
      Specular$dDom$dElement.classes(["btn", "btn-default", "btn-sm"]),
      Specular$dDom$dElement.attr("type")("button"),
      Specular$dDom$dElement.onClick_((() => {
        const $0 = pushItem1(l);
        return () => {$0();};
      })())
    ])(Specular$dInternal$dRIO.bindImpl(plusIcon)(() => Specular$dDom$dElement.text("Dodaj")));
  };
};
export {
  $DefaultEmptyLabel,
  $LabelMode,
  $UseDefault,
  DefaultEmptyLabel,
  LabelBooleanControl,
  LabelDefault,
  UseDefault,
  addButton,
  alertInfo,
  alertWarning,
  attachDyn,
  checkbox,
  checkboxField,
  checkboxField1,
  dateField,
  dateTimeLocalField,
  deleteButton,
  displayAlertWarning,
  displayErrorHint,
  displayErrorMessage,
  errorMessage,
  fieldLabelDefaultEmptyLab,
  fieldset,
  fieldset$p,
  fold,
  for_,
  formGroup,
  identity,
  infoText,
  isDefault,
  isVisible,
  isVisibleFieldLabel,
  label,
  labelString,
  labelUnit,
  labelWidget,
  mappingField,
  monadFRP,
  newRef,
  optionalWidget,
  panel,
  panel$p,
  panelToggle,
  panel_,
  plusIcon,
  priceField,
  radioGroup,
  readLabel,
  renderFieldLabel,
  renderLabel,
  renderLabelWithMode,
  selectField,
  sortIcon,
  subscribeDyn_,
  textAreaField,
  textField,
  textField$p,
  textField$p1,
  toGroupName,
  toGroupNameString,
  toGroupNameUseDefault,
  translatedFieldWrapper,
  translatedTextAreaField,
  translatedTextField,
  uniqDyn,
  unlessD,
  whenD,
  withDynamic_,
  withUniqDynamic_,
  withUniqDynamic_1,
  wrapItem
};
